import { Component, OnInit } from '@angular/core';
import { CartService } from 'src/app/services/api/cart.service';
import { LangService } from 'src/app/services/lang/lang.service';
import { FirebaseService } from 'src/app/services/firebase.service';
import { environment as env } from 'src/environments/environment';
import { Router } from '@angular/router';
// import { FbpixelService } from 'src/app/services/api/fbpixel.service';
import { FilesService, UseUploadedFiles } from 'src/app/services/api/files.service';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-totebag-artwork',
  templateUrl: './totebag-artwork.component.html',
  styleUrls: ['./totebag-artwork.component.scss']
})
export class TotebagArtworkComponent implements OnInit {

	onClose: any;
	product: any = null;
	selectedProductOptions: any = null;
	selectedQty: any = null;
	quoteId:any = null;
	quoteItemId:any = null;
	selectedQtyPrice: any = null;

	isAddingItemToCart:boolean = false;

	awupload: string = 'start';

	artworkOnly:any = false;
	config: any = null;

	/** upload */
	fileName: any = null;
	file: any = null;
	instructions: any = '';

	
	/**
	 * Start
	 * uploaded files section
	 */
	useUploadedFiles:UseUploadedFiles = new UseUploadedFiles()
	uploadedFiles:any = this.useUploadedFiles.uploadedFilesInit(this);
	/**
	 * End
	 * uploaded files section
	 */

	constructor(
		public lang: LangService,
		public cartService: CartService,
		public firebaseService: FirebaseService,
		// public fbpixel: FbpixelService,
		public router: Router,

		/** this is used by UseUploadedFiles */
		public filesService: FilesService,
		public sessionService: SessionService
	) { }

	ngOnInit(): void {
		this.cartService.get(this.cartService.getStoreUrl('/V1/lns-orderattachment/config')).subscribe(config => {
			this.config = config[0];
		});
	}
	
	/**
	 * close login modal
	 */
	closeModal(data:any = {}){
		this.onClose(data);
	}

	/**
	 * switch the modal to upload form
	 */
	uploadArtWorkForm(awu: string = ''){
		if(awu == "layout_catalog"){
			this.uploadedFiles.getUploadedFiles();
		}
		this.awupload = awu;
	}

	/**
	 * prepare the file to be uploaded on firestore
	 */
	prepareFile(event){
		let fName = event.target.files[0].name;
		let ext = fName.split('.');
		ext = ext[ext.length - 1];
		ext = ext.toLowerCase();

		if(this.config.accepted_file_type[ext]){
			this.fileName = fName;
			this.file = event;
		} else {
			this.fileName = null;
			this.file = null;
			let types: any = [];
			for (var key in this.config.accepted_file_type) {
				if (this.config.accepted_file_type.hasOwnProperty(key)) {
					types.push(key);
				}
			}
			types = types.join(', ');
			this.cartService.toastService.add('Please upload ' + types + ' only', 'danger');
		}
	}

	startAddToCartV2(){
		if(!this.artworkOnly){
			this.isAddingItemToCart = true;
			this.awupload = 'addingtocart';

			this.cartService.getCartId().then(quote_id => {
				if(quote_id){
					let jsonData = this.getJsonData(quote_id);
					
					let formData = new FormData();
					formData.append('item', JSON.stringify(jsonData));

					if(this.file){
						let file = this.file.target.files[0];
						formData.append('attachment', file);

						let path = env.firebase_path_prefix + 'order/quote_'+ quote_id + '/';
						formData.append('path', path);
						
						formData.append('instructions', this.instructions);
						this.awupload = 'uploaduprogress';
					} 
					
					if(this.uploadedFiles.selectedItem.id){
						formData.append('lns_orderattachment_files_id', this.uploadedFiles.selectedItem.id);
					}
					
					this.cartService.addToCartV2(formData, this.firebaseService).then(added => {
						this.cartService.getCart();
						this.cartService.toastService.add(this.lang.getLang('l47'), 'success');
						// this.router.navigate(["/cart"]);
						this.closeModal(added);
						this.cartService.setLoader(false);
						// this.fbPixel();
					});
				}
			});
		} else {
			let formData = new FormData();
			formData.append('quote_item_id', this.quoteItemId);

			
			if(this.uploadedFiles.selectedItem.id){
				formData.append('lns_orderattachment_files_id', this.uploadedFiles.selectedItem.id);
			}
			else {
				let path = env.firebase_path_prefix + 'order/quote_'+ this.quoteId + '/';
				formData.append('path', path);
	
				let file = this.file.target.files[0];
				formData.append('attachment', file);
	
				formData.append('instructions', this.instructions);
	
				this.awupload = 'uploaduprogress';
			}
			
			this.cartService.uploadArtWorkOnly(formData, this.firebaseService)
			.then(uploadResult => {
				this.closeModal("success");
			})
			.catch(error => {
				this.closeModal();
				this.cartService.toastService.add(error.message, "danger");
			});
		}
	}

	/**
	 * generate the json request data
	 */
	 getJsonData(quote_id: any = null){
		let d = new Date();
		let customOption: any = [
			{
				option_id: this.selectedProductOptions.size.option_id,
				option_value: this.selectedProductOptions.size.option_type_id,
			},
			{
				option_id: this.selectedProductOptions.do_not_merge.option_id,
				option_value: d.getTime(),
			}
		];

		if(this.selectedProductOptions.front_print_size.value){
			customOption.push({
				option_id: this.selectedProductOptions.front_print_size.option_id,
				option_value: this.selectedProductOptions.front_print_size.value,
			});
		}
		if(this.selectedProductOptions.back_print_size.value){
			customOption.push({
				option_id: this.selectedProductOptions.back_print_size.option_id,
				option_value: this.selectedProductOptions.back_print_size.value,
			});
		}

		let pl = Object.keys(this.selectedProductOptions.print_location);
		let plOptions:any = [];
		let plOptionId:any = 0;
		pl.forEach(key => {
			plOptionId = this.selectedProductOptions.print_location[key].option_id
			plOptions.push(this.selectedProductOptions.print_location[key].option_type_id);
		});
		customOption.push({
			option_id: plOptionId,
			option_values: plOptions
		});

		let jsonData = {
			"cartItem": {
				"sku": this.product.sku,
				"qty": this.selectedQty,
				"quote_id": quote_id,
				"product_option": {
					"extension_attributes": {
						"custom_options": customOption
					}
				},
				"extension_attributes": {}
			}
		};

		return jsonData;
	}
}
